
const albumImages = require.context(
  "../assets/img",
  true,
  /\.(png|jpe?g|webp|gif)$/i
);

export default function getAlbumImages(albumName) {
  const prefix = `./${albumName}/`;

  return albumImages
    .keys()
    .filter((file) => file.startsWith(prefix))
   .sort((a, b) =>
   b.localeCompare(a, undefined, { numeric: true })
)
    .map((file) => albumImages(file));
}

